// extracted by mini-css-extract-plugin
module.exports = {"details-input":"Signup_details-input__2wbwb"};